var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tech-preview text-uppercase d-inline-block"},[_vm._v(" "+_vm._s(_vm.$t('techPreview'))+" ")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }